import React from 'react';
import { getIntl } from '../../../../../utils/intl';
import Stack from '../../../../v2BaseComponents/Stack';
import Text from '../../../../v2BaseComponents/Text';
import ProgressBar from '../../../../v2BaseComponents/ProgressBar';

const intl = getIntl('components.screens.tabs.profiles.bulkInviteClientsScreen.inviteProgress', {
    sendingInvites: 'Sending {count} Invites',
});

export type InviteProgressOwnProps = {
    bulkInviteProgress: number;
    inviteCount: number;
};

export type InviteProgressProps = InviteProgressOwnProps;

const InviteProgress: React.FC<InviteProgressProps> = ({ bulkInviteProgress, inviteCount }) => {
    return (
        <Stack
            vertical
            fullHeight
            fullWidth
            justify="center"
            align="center"
            space={16}
            testID="bulk-invite-process-indicator"
        >
            <Text variant="h4">{intl('sendingInvites', { count: inviteCount })}</Text>
            <ProgressBar progress={bulkInviteProgress} style={{ width: 300 }} />
        </Stack>
    );
};

export default React.memo(InviteProgress);
